/*
 * @Author: ningbo.kang
 * @Date: 2019-11-29 10:41:56
 * @LastEditors: zerui.yao
 * @LastEditTime: 2024-03-29 17:40:47
 * @FilePath: /fed-authority/src/router/routes.js
 * @Description: 描述
 */
// 默认配置
import config from '@/config/defaultSettings';
import loaded from '@/utils/util.import';
import { frameIn, routeOrigin } from './frameIn';
import frameOut from './frameOut';

const allRoute = [];
const allRoutePerms = {};
routeOrigin.forEach((item) => {
  allRoute.push(item.path);
  allRoutePerms[item.path] = item.meta && item.meta.perms ? item.meta.perms[0] : '';
});

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载

/**
 * 错误页面
 */
const notFoundRouter = [
  {
    path: '*',
    component: loaded('exception/404'),
    // 未匹配路径适配布局
    beforeEnter: (to, from, next) => {
      // 未匹配到，已登录时跳转到 /exception/404
      if (allRoute.includes(to.path)) {
        next(`/exception/403?permission=${allRoutePerms[to.path]}`);
      } else {
        next();
      }
    },
  },
];

// 动态路由，动态是指与权限有关，会过滤掉无权限理由
const asyncRouterMap = [...frameIn];
if (config.permission) {
  asyncRouterMap.length = 0;
}
// 导出需要显示菜单的
export const frameInRoutes = frameIn;

// 三部分组成
export default [...asyncRouterMap, ...frameOut, ...notFoundRouter];
